<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import LayoutMainPage from '@/components/LayoutMainPage.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import GalleryMenu from '@/components/GalleryMenu.vue'
import GallerySlideshow from '@/components/GallerySlideshow.vue'
import ItemPicture from '@/components/ItemPicture.vue'
import ItemCaption from '@/components/ItemCaption.vue'
import MainHead from '@/components/MainHead.vue'
import MainNav from '@/components/MainNav.vue'
import PopupDesc from '@/components/PopupDesc.vue'
import PopupList from '@/components/PopupList.vue'
import IdleTimer from '@/components/IdleTimer.vue'
import { useMenuStore } from '@/stores/gallery/menu'
import { useSlideshowStore } from '@/stores/gallery/slideshow'
import { usePopupStore } from '@/stores/popup'
import { useMainStore } from '../stores/main'


console.log('[Main] setup ....')

const mainStore = useMainStore()
const menuStore = useMenuStore()
const slideshowStore = useSlideshowStore()
const { popup } = storeToRefs(usePopupStore())

const main_nextItemTimeout = config.idleTimer.main_nextItemTimeout * 1000
const main_nextItemFlipBackTimeout = config.idleTimer.main_nextItemFlipBackTimeout * 1000

// State -----------------------------------------

// Getters ---------------------------------------
const activedItem = computed(() => slideshowStore.activedItem)
const isFlipBack = computed(() => mainStore.isFlipBack)

// Methods ---------------------------------------

// Events ----------------------------------------
// onMounted(() => {
//   console.log('onMounted()')
//   setTimeout(() => {
//     slideshowStore.setActivedItem(54)
//     // onClickBtnList()
//   }, 300)
// })

menuStore.$onAction(({ name, store, args, after, onError }) => {
  console.debug(`%c[Main] ${store.$id}.$onAction  ->`, style.debug, name, args)
  after((result) => {
    const items = slideshowStore.items.filter((e) => e.place == store.place && e.category == store.category)
    if (items.length) {
      slideshowStore.setActivedItem(items[0].id)
    } else {
      slideshowStore.clearActivedItem()
    }
  })
})

slideshowStore.$onAction(({ name, store, args, after, onError }) => {
  console.debug(`%c[Main] ${store.$id}.$onAction ->`, style.debug, name, args)
  after((result) => {
    const actions = ['setActivedItem', 'setActivedItemNext']
    if (actions.includes(name)) {
      menuStore.$patch({ place: store.activedItem.place, category: store.activedItem.category })
    }
  })
})

watch(activedItem, (newValue, oldValue) => {
  if (activedItem.value !== undefined) {
    console.info('%citem: %d %O', style.info, newValue.id, { ...activedItem.value })
    mainStore.setFlipBack(false)
  }
})

function onIdleTrigger_mainNextItem() {
  console.info('%c[Main] onIdleTrigger_mainNextItem()', style.info)
  slideshowStore.setActivedItemNext()
}

function onIdleTrigger_mainNextItemFlipBack() {
  console.info('%c[Main] onIdleTrigger_mainNextItemFlipBack()', style.info)
  slideshowStore.setActivedItemNext()
  mainStore.setFlipBack(false)
}

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <main>
    <LayoutMainPage>
      <template #timer>
        <template v-if="!isFlipBack">
          <idle-timer
            v-if="main_nextItemTimeout"
            title="Main.NextItemTimeout"
            color="blue"
            :timeout="main_nextItemTimeout"
            @idle-trigger="onIdleTrigger_mainNextItem"
          />
        </template>
        <template v-else>
          <idle-timer
            v-if="main_nextItemFlipBackTimeout"
            title="Main.NextItemFlipBackTimeout"
            color="red"
            :timeout="main_nextItemFlipBackTimeout"
            @idle-trigger="onIdleTrigger_mainNextItemFlipBack"
          />
        </template>
      </template>
      <template #nav>
        <LanguageSwitcher />
      </template>
      <template #content>
        <MainHead />
        <ItemPicture />
        <transition name="fade-popup" mode="out-in" appear>
          <PopupDesc v-if="popup === 'PopupDesc'" />
          <PopupList v-else-if="popup == 'PopupList'" />
          <div v-else>
            <ItemCaption />
            <MainNav />
          </div>
        </transition>
      </template>
      <template #gallery>
        <GalleryMenu />
        <GallerySlideshow />
      </template>
    </LayoutMainPage>
  </main>
</template>

<style scoped>
/* ------------------------ */
.fade-popup-enter-active,
.fade-popup-leave-active {
  transition: opacity 0.3s ease;
}
.fade-popup-enter-from,
.fade-popup-leave-to {
  opacity: 0;
}

/* ------------------------ */
.language-switcher {
  top: 1468px;
  left: 925px;
}

.gallery-menu {
  left: 0;
  top: 0;
}

.gallery-slideshow {
  left: 0;
  top: 60px;
  z-index: var(--layer-5);
}

.main-head {
  left: 540px;
  top: 360px;
}

.main-nav {
  left: 581px;
  top: 1250px;
}

.item-picture {
  left: 0;
  top: 0;
}

.item-caption {
  left: 580px;
  top: 680px;
}

.popup-desc,
.popup-list {
  left: 581px;
  top: 690px;
  z-index: var(--layer-3);
}

/* ------------------------ */
</style>
